import { Injectable, inject } from '@angular/core';
import { ConfigService, ListLayout, ListLayoutMultipleComponent } from 'gung-list';
import { ActivatedRouteSnapshot } from '@angular/router';
import { map, Observable } from 'rxjs';
import { ExportCoverSheet } from '../../models/export-cover-sheets';
import { ExportCoverSheetsService } from './export-cover-sheets.service';
import { ExportCoverSheetsTableComponent } from '../../components/export-cover-sheets/export-cover-sheets-table/export-cover-sheets-table.component';

@Injectable({
  providedIn: 'root'
})
export class ExportCoverSheetsConfigService implements ConfigService<ExportCoverSheet> {
  searchDisabled = true;
  topFilter = true;

  protected exportCoverSheetsService = inject(ExportCoverSheetsService);

  getItems(route?: ActivatedRouteSnapshot): Observable<ExportCoverSheet[]> {
    return this.exportCoverSheetsService.getExportCoverSheets(true).pipe(
      map((sheets: ExportCoverSheet[]) => sheets.sort((a, b) => (a.index < b.index ? -1 : 1)))
    );
  }

  getFilters(route?: ActivatedRouteSnapshot) {
    return [];
  }

  getLayouts(route?: ActivatedRouteSnapshot): ListLayout<ExportCoverSheet>[] {
    return [
      {
        getIconClass: () => '',
        getListItemComponent: () => ExportCoverSheetsTableComponent,
        getListLayoutComponent: () => ListLayoutMultipleComponent,
        getName: () => 'Export Sheet List'
      }
    ];
  }

  getSortOptions() {
    return [];
  }

  getBatchSizes() {
    return [24];
  }

  getSearchTerms(item: ExportCoverSheet): string[] {
    return [item.name];
  }

  getItemId(item: ExportCoverSheet): string {
    return item.id;
  }
}
